export default __webpack_public_path__ + "static/media/plus.dc424d02.svg";